import styled from '@emotion/styled'

import { theme } from '../../constants'
import { Color } from '../../constants/color'
import { Clickable, ClickableProps } from '../Clickable'
import { Icon, IconProps } from '../Icon'
import { Tooltip } from '../Tooltip'

// TODO: shouldn't icon inherit color?
const Hoverable = styled(Clickable)({
  border: `1px solid ${Color.TRANSPARENT}`,
  borderRadius: theme.border.radius.small,
  padding: theme.spacing[1],
  flex: 0,
  ':not(:disabled):hover': {
    borderColor: Color.GREY,
    background: Color.LIGHT_GREY,

    div: {
      color: Color.BLUE,
    },
  },
})

export type ClickableIconProps = {
  iconProps: IconProps
  clickableProps?: ClickableProps
  disabled?: boolean
  onClick?: () => void
  tooltipText?: string
}

export const ClickableIcon = (props: ClickableIconProps) => {
  const content = (
    <Hoverable
      {...props.clickableProps}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      <Icon {...props.iconProps} />
    </Hoverable>
  )

  return props.tooltipText ? (
    <Tooltip text={props.tooltipText}>
      <Tooltip.Trigger asChild>{content}</Tooltip.Trigger>
    </Tooltip>
  ) : (
    content
  )
}
